/* OPQ Shop — cursor-following thermal scope.
   A fixed circular div uses `backdrop-filter: url(#opq-shop-thermal)` to
   re-map whatever is behind it (product images, page chrome, etc.) into a
   thermal-imaging colour ramp via SVG feComponentTransfer.  The element
   tracks pointermove on rAF for smooth motion. */

function initShopCursorThermal(root) {
  const mask = root.querySelector('[data-opq-shop-cursor]');
  if (!mask) return;

  let raf = 0;
  let x = 0;
  let y = 0;
  let visible = false;

  const update = () => {
    raf = 0;
    mask.style.transform = `translate(${x}px, ${y}px) translate(-50%, -50%)`;
  };

  const show = () => {
    if (visible) return;
    visible = true;
    mask.classList.add('is-active');
  };

  const hide = () => {
    visible = false;
    mask.classList.remove('is-active');
    mask.style.transform = 'translate(-9999px, -9999px)';
  };

  window.addEventListener('pointermove', (e) => {
    x = e.clientX;
    y = e.clientY;
    show();
    if (!raf) raf = requestAnimationFrame(update);
  }, { passive: true });

  document.addEventListener('mouseleave', hide);
  window.addEventListener('blur', hide);
}

document.querySelectorAll('.opq-shop').forEach(initShopCursorThermal);
